import { Award, Truck, ShieldCheck, Headphones } from 'lucide-react'
import type { BenefitItem } from '../../model/types'

const ICONS: Record<string, React.ComponentType<{ className?: string }>> = {
  'award': Award,
  'truck': Truck,
  'shield-check': ShieldCheck,
  'headphones': Headphones,
}

export function BenefitCard({ item }: { item: BenefitItem }) {
  const Icon = ICONS[item.icon] ?? Award
  return (
    <div className="flex items-center gap-4 px-5 py-4">
      <div className="w-12 h-12 rounded-full bg-brand-50 flex items-center justify-center text-brand-600 shrink-0">
        <Icon className="w-6 h-6" />
      </div>
      <div className="leading-tight">
        <div className="text-sm text-text">{item.label}</div>
        <div className="text-brand-600 font-bold text-lg">{item.highlight}</div>
      </div>
    </div>
  )
}
